//  -*-web-*-
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider,
	 DatePicker
} from '@material-ui/pickers';
import {maxFutureTime } from './TimeDateUtils.js';

// --------------------------------------------------------------------
// DatePicker for React
// --------------------------------------------------------------------
export function ChartDatePicker(props) {
    var date = new Date(props.val);
    date = adjustWeekday(date, props.country);
    
    const handleValue = (val) => {
	date = adjustWeekday(new Date(val), props.country);
	if (props.onClick) props.onClick(props, date);
    };

    return (
	<MuiPickersUtilsProvider utils={DateFnsUtils}>
	<DatePicker
	label="Date:"
	disableToolbar
	autoOk="true"
	//inputVariant="outlined"
	allowKeyboardControl={true}
	variant="inline"
	format="yyy-MM-dd"
	value={date}
	onChange={handleValue}
	/>
	</MuiPickersUtilsProvider>
    );
}


// --------------------------------------------------------------------
// Checks a date and makes sure no weekends are chosen and no future
// date is set.
// --------------------------------------------------------------------
function adjustWeekday(date, country)
{
    var maxtime = maxFutureTime(country);
    var weekday = date.getDay(); // Sun=0, Mon=1, ...

    // Assuming Sunday means we are moving backwards and Saturday that
    // we are moving forwards
    if (weekday === 0) date.setDate(date.getDate()-2); // Sun => Fri
    else if (weekday === 6) date.setDate(date.getDate()+2); // Sat => Mon
    if (date > maxtime) date = maxtime;
    return date;
}
